import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type {
  DataSourceInfo,
  LivePslfData,
  LiveTasData,
  LiveSection127Info,
} from 'tio-employee/services/reimagined-data';
import type {
  FinancialSnapshot,
  EmployerContributions,
} from 'tio-employee/services/career-pathways-api';

export interface ReimaginedHomeModel {
  financialSnapshot: FinancialSnapshot;
  dataSourceInfo: DataSourceInfo;
  employerContributions: { contributions: EmployerContributions; isLiveData: boolean };
  pslfData: LivePslfData;
  tasData: LiveTasData;
  section127Info: LiveSection127Info;
}

export default class AuthenticatedReimaginedHomeRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model(): Promise<ReimaginedHomeModel> {
    const [
      financialSnapshot,
      dataSourceInfo,
      employerContributions,
      pslfData,
      tasData,
      section127Info,
    ] = await Promise.all([
      this.reimaginedData.fetchFinancialSnapshot(),
      this.reimaginedData.getDataSourceInfo(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.fetchPslfData(),
      this.reimaginedData.fetchTasData(),
      this.reimaginedData.fetchSection127Info(),
    ]);

    return {
      financialSnapshot,
      dataSourceInfo,
      employerContributions,
      pslfData,
      tasData,
      section127Info,
    };
  }
}
